import React from 'react';
import PropTypes from 'prop-types'; // Importando para validação das props
import './TitlePage.css';

const TitlePage = ({ title, subtitle }) => {
    return (
        <header className="header-title">
            <h1>{title}</h1>
            {subtitle && <p>{subtitle}</p>} {/* Exibe o subtítulo somente se ele existir */}
        </header>
    );
};

// Validação das props
TitlePage.propTypes = {
    title: PropTypes.string.isRequired,  // Garantindo que o título seja sempre uma string
    subtitle: PropTypes.string, // O subtítulo é opcional
};

export default TitlePage;
